import React from "react";
import { TextField, InputAdornment } from "@mui/material";

const formatValue = (raw) => {
  if (raw === "" || raw === null || raw === undefined) return "";
  const num = Number(String(raw).replace(/[^0-9.-]/g, ""));
  if (Number.isNaN(num)) return "";
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

const parseValue = (display) => {
  if (display === "" || display == null) return "";
  const cleaned = String(display).replace(/[^0-9.-]/g, "");
  if (cleaned === "" || cleaned === "-") return cleaned;
  const num = Number(cleaned);
  return Number.isNaN(num) ? "" : num;
};

const DollarInput = ({ value, onChange, onBlur, disabled, fullWidth, placeholder, error, helperText }) => {
  const [display, setDisplay] = React.useState(formatValue(value));

  React.useEffect(() => {
    setDisplay(formatValue(value));
  }, [value]);

  return (
    <TextField
      value={display}
      onChange={(e) => {
        const raw = e.target.value;
        setDisplay(raw);
        onChange(parseValue(raw));
      }}
      onBlur={(e) => {
        setDisplay(formatValue(value));
        if (onBlur) onBlur(e);
      }}
      placeholder={placeholder}
      disabled={disabled}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      inputProps={{ inputMode: "decimal" }}
    />
  );
};

export default DollarInput;
